import { Component, Host, h } from '@stencil/core';
import state from '@ugc-store';
import { getStoreReview } from '@ugc-api/store-review';
import { StoreReviewApiType } from '@ugc-components/ugc-store-review/type';

@Component({
  tag: 'ugc-shipping',
  shadow: false,
})
export class UgcShipping {
  async componentWillLoad() {
    try {
      const data = await getStoreReview(StoreReviewApiType.shipping);
      state.shippingList = data;
    } catch (e) {}
  }

  render() {
    const { isDesktop, shippingList } = state;

    if (!shippingList.length) return null;

    return (
      <Host class={{ 'ugc-global-css-wrap': true, isDesktop }}>
        <div class="ugc-component-wrap">
          <shipping-divider />
          <shipping-head />
          <shipping-slide />
          <shipping-foot />
        </div>
      </Host>
    );
  }
}
